// Bearer-token store. In production (admin.rainfallmeditation.com behind
// Cloudflare Access) the dashboard's auth is the Access magic-link itself,
// and the bearer is only needed to talk to the Worker. We keep the token
// in localStorage for convenience during dev; in prod, Access could be
// extended to forward the JWT to the Worker (already accepted server-side
// via Cf-Access-Jwt-Assertion).

const KEY = "rainfall.admin.bearer";
const API_KEY = "rainfall.admin.apiBase";

export function getToken(): string | null {
  return localStorage.getItem(KEY);
}

export function setToken(t: string | null) {
  if (t) localStorage.setItem(KEY, t);
  else localStorage.removeItem(KEY);
}

export function getApiBase(): string {
  return localStorage.getItem(API_KEY) ?? "https://api.rainfallmeditation.com";
}

export function setApiBase(url: string) {
  localStorage.setItem(API_KEY, url.replace(/\/+$/, ""));
}
